export interface BackendErrorEvent {
  errorCode?: number | null;
  type?: string | null;
  cavorsRequestId?: string | null;
  cavorsSessionId?: string | null;
  message?: string | null;
  parameters?: Record<string, unknown> | null;
}

export function isBackendErrorEvent(event: unknown): event is BackendErrorEvent {
  return typeof event === 'object' && event !== null && 'errorCode' in event && 'type' in event && 'message' in event;
}
